import ProductPage from './ProductPage';

const features = [
  { heading: 'Built for your business', text: 'Mark attendance with a selfie tagged so you always know who showed up.', icon: '📱' },
  { heading: 'Save time every day', text: 'Manager mode lets supervisors approve attendance, mark absent, and apply late fines or overtime in one tap.', icon: '⏱' },
  { heading: 'Secure and reliable', text: 'Bank-grade encryption, role-based access and daily backups keep your business data safe.', icon: '🔒' },
];

export default function PremiumApp() {
  return (
    <ProductPage
      title="Premium App"
      subtitle="Get premium features like selfie and location-based attendance, manager mode and a built-in cashbook."
      features={features}
      ctaTitle="Premium App"
    />
  );
}
